import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

function Webcaseprojects() {
  return (
    <section className="webcase_projects p-100" id="case_btn">
      <Container>
        <Row>
          <Col
            xs={12}
            md={10}
            lg={9}
            xl={9}
            xxl={9}
            className="text-center m-auto"
          >
            <h2>
              Our Web Development <span>Projects</span> – Ground-Up Launches to
              Makeovers
            </h2>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <Swiper
              loop={true}
              autoplay={{
                delay: 3000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
              }}
              // autoplay={false}
              spaceBetween={20}
              modules={[Autoplay, Pagination]}
              pagination={{ clickable: true }}
              breakpoints={{
                320: {
                  slidesPerView: 1,
                },
                768: {
                  slidesPerView: 1,
                },
                1024: {
                  slidesPerView: 1.3,
                },
                1366: {
                  slidesPerView: 1.4,
                },
                1600: {
                  slidesPerView: 1.6,
                },
              }}
              className="web_case_slider"
            >
              <SwiperSlide>
                <div className="web_pro_item">
                  <div className="web_pro_content">
                    <div className="web_pro_logo">
                      <StaticImage
                        src="../../images/services-usa/web/pure_logo.webp"
                        alt="tekrevol_web"
                        layout="constrained"
                        placeholder="blurred"
                        formats={["webp"]}
                        width={200}
                        height={60}
                      />
                    </div>
                    <div className="web_pro_head">
                      <h2>
                        Online platform for fitness and exercise enthusiasts
                      </h2>
                      <h5>
                        <span>3x</span> Increase in Website Traffic
                      </h5>
                    </div>
                    <div className="web_pro_btn">
                      <Link
                        to="/case-studies/pure-plank"
                        aria-label="TekRevol Contact"
                      >
                        View Case Study
                      </Link>
                    </div>
                  </div>
                  <div className="web_pro_img">
                    <StaticImage
                      src="../../images/services-usa/web/pureplank.webp"
                      alt="pure plank"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={724}
                      height={387}
                    />
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="web_pro_item">
                  <div className="web_pro_content">
                    <div className="web_pro_logo">
                      <StaticImage
                        src="../../images/services-usa/web/alhussaini_logo.webp"
                        alt="tekrevol_web"
                        layout="constrained"
                        placeholder="blurred"
                        formats={["webp"]}
                        width={200}
                        height={60}
                      />
                    </div>
                    <div className="web_pro_head">
                      <h2>Leading marketplace for watches and jewelry</h2>
                      <h5>
                        <span>110%</span> Increase in Leads
                      </h5>
                    </div>
                    <div className="web_pro_btn">
                      <Link
                        to="/case-studies/alhussaini"
                        aria-label="TekRevol Contact"
                      >
                        View Case Study
                      </Link>
                    </div>
                  </div>
                  <div className="web_pro_img">
                    <StaticImage
                      src="../../images/services-usa/web/alhussaini.webp"
                      alt="alhussaini"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={724}
                      height={387}
                    />
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="web_pro_item">
                  <div className="web_pro_content">
                    <div className="web_pro_logo">
                      <StaticImage
                        src="../../images/services-usa/web/select_logo.webp"
                        alt="tekrevol_web"
                        layout="constrained"
                        placeholder="blurred"
                        formats={["webp"]}
                        width={200}
                        height={60}
                      />
                    </div>
                    <div className="web_pro_head">
                      <h2>Complete dealership solution</h2>
                      <h5>
                        <span>150%</span> Increase in Conversions
                      </h5>
                    </div>
                    <div className="web_pro_btn">
                      <Link
                        to="/case-studies/select-dealer"
                        aria-label="TekRevol Contact"
                      >
                        View Case Study
                      </Link>
                    </div>
                  </div>
                  <div className="web_pro_img">
                    <StaticImage
                      src="../../images/services-usa/web/select_dealer_case.webp"
                      alt="select dealer"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={724}
                      height={387}
                    />
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="web_pro_item">
                  <div className="web_pro_content">
                    <div className="web_pro_logo">
                      <StaticImage
                        src="../../images/services-usa/web/talpool_logo.webp"
                        alt="tekrevol_web"
                        layout="constrained"
                        placeholder="blurred"
                        formats={["webp"]}
                        width={200}
                        height={60}
                      />
                    </div>
                    <div className="web_pro_head">
                      <h2>Leading talent networking platform</h2>
                      <h5>
                        <span>2x</span> Increase in Website Traffic
                      </h5>
                    </div>
                    <div className="web_pro_btn">
                      <Link
                        to="/case-studies/talpool"
                        aria-label="TekRevol Contact"
                      >
                        View Case Study
                      </Link>
                    </div>
                  </div>
                  <div className="web_pro_img">
                    <StaticImage
                      src="../../images/services-usa/web/talpool.webp"
                      alt="talpool"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={724}
                      height={387}
                    />
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="web_pro_item">
                  <div className="web_pro_content">
                    <div className="web_pro_logo">
                      <StaticImage
                        src="../../images/services-usa/web/impact_logo.webp"
                        alt="tekrevol_web"
                        layout="constrained"
                        placeholder="blurred"
                        formats={["webp"]}
                        width={200}
                        height={60}
                      />
                    </div>
                    <div className="web_pro_head">
                      <h2>Platform to increase student's productivity</h2>
                      <h5>
                        <span>1.5x</span> Increase in Revenue
                      </h5>
                    </div>
                    <div className="web_pro_btn">
                      <Link
                        to="/case-studies/impact"
                        aria-label="TekRevol Contact"
                      >
                        View Case Study
                      </Link>
                    </div>
                  </div>
                  <div className="web_pro_img">
                    <StaticImage
                      src="../../images/services-usa/web/impact_img.webp"
                      alt="project impact"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={724}
                      height={387}
                    />
                  </div>
                </div>
              </SwiperSlide>
            </Swiper>

            {/* <Carousel
              responsive={responsive}
              infinite={true}
              autoPlay={false}
              autoPlaySpeed={3000}
              showDots={false}
              arrows={false}
            >
              <div className="web_pro_item">
                <div className="web_pro_content">
                  <div className="web_pro_logo">
                    <StaticImage
                      src="../../images/services-usa/web/pure_logo.webp"
                      alt="tekrevol_web"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={260}
                      height={80}
                    />
                  </div>
                  <div className="web_pro_head">
                    <h2>
                      Online platform for fitness and exercise enthusiasts
                    </h2>
                    <h5>
                      <span>3x</span> Increase in Website Traffic
                    </h5>
                  </div>
                  <div className="web_pro_btn">
                    <Link to="/pure-plank" aria-label="TekRevol Contact">
                      View Case Study
                    </Link>
                  </div>
                </div>
                <div className="web_pro_img">
                  <StaticImage
                    src="../../images/services-usa/web/pureplank.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={724}
                    height={387}
                  />
                </div>
              </div>
              <div className="web_pro_item">
                <div className="web_pro_content">
                  <div className="web_pro_logo">
                    <StaticImage
                      src="../../images/services-usa/web/alhussaini_logo.webp"
                      alt="tekrevol_web"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={202}
                      height={49}
                    />
                  </div>
                  <div className="web_pro_head">
                    <h2>Leading marketplace for watches and jewelry</h2>
                    <h5>
                      <span>110%</span> Increase in Leads
                    </h5>
                  </div>
                  <div className="web_pro_btn">
                    <Link to="/alhussaini" aria-label="TekRevol Contact">
                      View Case Study
                    </Link>
                  </div>
                </div>
                <div className="web_pro_img">
                  <StaticImage
                    src="../../images/services-usa/web/alhussaini.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={724}
                    height={387}
                  />
                </div>
              </div>
              <div className="web_pro_item">
                <div className="web_pro_content">
                  <div className="web_pro_logo">
                    <StaticImage
                      src="../../images/services-usa/web/case-logo-3.webp"
                      alt="tekrevol_web"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={180}
                      height={90}
                    />
                  </div>
                  <div className="web_pro_head">
                    <h2>Complete solution for dealer clients</h2>
                    <h5>
                      <span>150%</span> Increase in Conversions
                    </h5>
                  </div>
                  <div className="web_pro_btn">
                    <Link to="/select-dealer" aria-label="TekRevol Contact">
                      View Case Study
                    </Link>
                  </div>
                </div>
                <div className="web_pro_img">
                  <StaticImage
                    src="../../images/services-usa/web/select_dealer_case.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={724}
                    height={387}
                  />
                </div>
              </div>
              <div className="web_pro_item">
                <div className="web_pro_content">
                  <div className="web_pro_logo">
                    <StaticImage
                      src="../../images/services-usa/web/talpool_logo.webp"
                      alt="tekrevol_web"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={206}
                      height={90}
                    />
                  </div>
                  <div className="web_pro_head">
                    <h2>Leading talent networking platform</h2>
                    <h5>
                      <span>2x</span> Increase in Website Traffic
                    </h5>
                  </div>
                  <div className="web_pro_btn">
                    <Link to="/talpool" aria-label="TekRevol Contact">
                      View Case Study
                    </Link>
                  </div>
                </div>
                <div className="web_pro_img">
                  <StaticImage
                    src="../../images/services-usa/web/talpool.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={724}
                    height={387}
                  />
                </div>
              </div>
              <div className="web_pro_item">
                <div className="web_pro_content">
                  <div className="web_pro_logo">
                    <StaticImage
                      src="../../images/services-usa/web/impact_logo.webp"
                      alt="tekrevol_web"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={189}
                      height={69}
                    />
                  </div>
                  <div className="web_pro_head">
                    <h2>Platform to increase student's productivity</h2>
                    <h5>
                      <span>1.5x</span> Increase in Revenue
                    </h5>
                  </div>
                  <div className="web_pro_btn">
                    <Link to="/impact" aria-label="TekRevol Contact">
                      View Case Study
                    </Link>
                  </div>
                </div>
                <div className="web_pro_img">
                  <StaticImage
                    src="../../images/services-usa/web/impact_img.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={724}
                    height={387}
                  />
                </div>
              </div>
            </Carousel> */}
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Webcaseprojects;
